export const APP_HEADER_HEIGHT = {
  MOBILE: 64,
  MOBILE_WITH_COMPANION: 116,
  DESKTOP: 94,
} as const;

export const APP_HEADER_HEIGHT_CSS_VAR = "--vn-app-header-height";

export function getAppHeaderHeightPx(options: {
  showMobileCompanionBar: boolean;
  isBelowDesktop: boolean;
}): number {
  if (!options.isBelowDesktop) {
    return APP_HEADER_HEIGHT.DESKTOP;
  }

  return options.showMobileCompanionBar
    ? APP_HEADER_HEIGHT.MOBILE_WITH_COMPANION
    : APP_HEADER_HEIGHT.MOBILE;
}
